

export default {
  name: "textStyle",
  nickname: "文本样式",
  desc: "提示框浮层的文本样式。",
  type: "object",
  props: {
    color: {
      name: "color",
      nickname: "颜色",
      desc: "文字的颜色。",
      value: "#fff",
      defaultValue: "#fff",
      type: "pureValue",
      eType: "color",
    },
    fontStyle: {
      name: "fontStyle",
      nickname: "字体样式",
      desc: "文字字体的风格",
      value: "normal",
      defaultValue: "normal",
      type: "pureValue",
    },
    fontWeight: {
      name: "fontWeight",
      nickname: "字体粗细",
      desc: "文字字体的粗细",
      value: "normal",
      defaultValue: "normal",
      type: "pureValue",
    },
    fontFamily: {
      name: "fontFamily",
      nickname: "字体",
      desc: "文字的字体系列",
      value: "sans-serif",
      defaultValue: "sans-serif",
      type: "pureValue",
    },
    fontSize: {
      name: "fontSize",
      nickname: "字体大小",
      desc: "文字的字体大小",
      value: 14,
      defaultValue: 14,
      type: "pureValue",
    },
    lineHeight: {
      name: "lineHeight",
      nickname: "行高",
      desc: "行高。",
    },
    width: {
      name: "width",
      nickname: "宽度",
      desc:
        '文字块的宽度。一般不用指定，不指定则自动是文字的宽度。在想做表格项或者使用图片（参见 <code class="codespan">backgroundColor</code>）时，可能会使用它。',
    },
    height: {
      name: "height",
      nickname: "高度",
      desc:
        '文字块的高度。一般不用指定，不指定则自动是文字的高度。在使用图片（参见 <code class="codespan">backgroundColor</code>）时，可能会使用它。',
    },
    textBorderColor: {
      name: "textBorderColor",
      nickname: "文本边框颜色",
      desc: "文字本身的描边颜色。",
      value: "transparent",
      defaultValue: "transparent",
      type: "pureValue",
    },
    textBorderWidth: {
      name: "textBorderWidth",
      nickname: "文本边框宽度",
      desc: "文字本身的描边宽度。",
      value: 0,
      defaultValue: 0,
    },
    textShadowColor: {
      name: "textShadowColor",
      nickname: "文本阴影宽度",
      desc: "文字本身的阴影颜色。",
      value: "transparent",
      defaultValue: "transparent",
      type: "pureValue",
    },
    textShadowBlur: {
      name: "textShadowBlur",
      nickname: "文本阴影长度",
      desc: "文字本身的阴影长度。",
      value: 0,
      defaultValue: 0,
    },
    textShadowOffsetX: {
      name: "textShadowOffsetX",
      nickname: "文本阴影X偏移",
      desc: "文字本身的阴影 X 偏移。",
      value: 0,
      defaultValue: 0,
    },
    textShadowOffsetY: {
      name: "textShadowOffsetY",
      nickname: "文本阴影Y偏移",
      desc: "文字本身的阴影 Y 偏移。",
      value: 0,
      defaultValue: 0,
    },
  },
}
